<!--  -->
<template>
  <div class="page" :class="{ active: isApp || miniprogram }">
    <common-title
      v-if="!isApp && !miniprogram"
      :titleName="courseDetail&&courseDetail.name || '课程体验'"
      :zIndex="1000"
    ></common-title>
    <div class="ad">
      <img @click="toDetail" :src="classInfo.coverImg" alt="" />
    </div>
    <div class="teacher">
      <h1 class="title">师资介绍</h1>
      <div class="banner">
        <div class="slide" v-for="(item, k) in teacherList" :key="k" @click="toTeacherDetail(item)">
          <div class="head">
            <div class="name">{{ item.publicName }}</div>
            <p class="teacherMajors" v-if="item.disciplineVOList">
              <span v-for="(item, i) in teachMainModule(item.disciplineVOList)" :key="i">{{
                item
              }}</span>
            </p>
          </div>
          <div class="img">
            <img
              :src="item.topicWebHead || require('../../assets/img/loginImg/default.png')"
              alt=""
            />
          </div>
          <div class="desc">
            <div>{{ item.teacherBrief }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="main" v-if="isShowAudition">
      <h1 class="title">课程试听</h1>
      <div class="cover" @click="toAudition">
        <img class="img" :src="courseDetail.coverMobile" alt="" />
        <img
          class="audition"
          src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/studyBook/shiting.png"
        />
      </div>
    </div>
    <div class="server" v-if="learnServiceList.length">
      <h1 class="title">服务体验</h1>
      <div class="box">
        <div class="item" v-for="(item, k) in learnServiceList" :key="k" @click="toServer(k)">
          <img :src="item.icon" />
          <p>{{ item.title }}</p>
        </div>
      </div>
    </div>
    <div class="foot">
      <div class="look" @click="toDetail">查看产品</div>
      <div class="buy" @click="toBuy">立即购买</div>
    </div>
    <SelectSku ref="sku" v-if="courseDetail" :courseInfo="courseDetail" @sendSku="sendSku" />
  </div>
</template>

<script>
import wx from 'weixin-js-sdk';
import { mapState } from 'vuex';
import { reqCourseDetail, reqIsBuyProduct, reqCatalogs } from '@/api/courseDetail/index';
import classService from './components/classType';
import { reqTypeList } from '@/api/home';
import { reqTeacherList } from '@/api/studyBook/index';
import SelectSku from './components/selectSku.vue';

export default {
  components: {
    SelectSku,
  },
  data() {
    return {
      isApp: this.$root.$data.isApp,
      miniprogram: this.$root.$data.miniprogram,
      courseDetail: null,
      teacherList: [],
      serviceList: [],
      learnServiceList: [],
      isShowAudition: false,
      classInfo: {},
      buyInfo: [],
    };
  },
  computed: {
    ...mapState(['userInfo']),
  },
  watch: {},
  methods: {
    // 查课程
    async getCourseDetail() {
      const { courseId } = this.$route.query;
      this.$toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true,
      });
      const { data } = await reqCourseDetail(courseId);
      const { productAttributeRespVOS, productSkuRespVOList } = data;
      const {
        containCurriculumId,
        productStudyToolInfoRespVOList,
        isContainStageTest,
        isContainQa,
        isContainHomeWork,
        isContainQuestionBank,
      } = productSkuRespVOList?.[0];
      productAttributeRespVOS.forEach((element) => {
        if (element.extendAttributeNameEn === 'classType') {
          const classType = element.dataJson;
          if (classService[classType]) {
            this.classInfo = classService[classType];
            console.log(this.classInfo.name,'this.classInfo.name');

            const serviceList = this.classInfo?.learnService?.split(',');
            if (isContainStageTest) {
              serviceList.push(17);
            }
            if (isContainQa) {
              serviceList.push(6);
            }
            if (isContainHomeWork) {
              serviceList.push(7);
            }
            if (isContainQuestionBank) {
              serviceList.push(19);
            }
            productStudyToolInfoRespVOList.forEach((item) => {
              if (item.code === 'word') {
                serviceList.push(11);
              }
              if (item.code === 'longSentence') {
                serviceList.push(12);
              }
              if (item.code === 'zhangyuPractice') {
                serviceList.push(8);
              }
              if (item.code === 'politics') {
                serviceList.push(15);
              }
              if (item.code === 'composition') {
                serviceList.push(20);
              }
            });
            console.log(serviceList, 'serviceList');
            this.serviceList = serviceList;
            this.getDictionary(serviceList);
          }
        }
        if (element.extendAttributeNameEn === 'teacher') {
          this.getTeacher(JSON.parse(element.dataJson));
        }
      });
      this.courseDetail = data;
      document.title = this.courseDetail?.name||'课程体验';
      this.getCatalog(containCurriculumId);
      this.checkCourse(courseId);
    },
    // 查询课表
    async getCatalog(containCurriculumId) {
      if (!containCurriculumId) {
        this.$toast.clear();
        return;
      }
      const { data } = await reqCatalogs(containCurriculumId);
      this.$toast.clear();
      const { videoInfoRespVOS } = data;
      this.isShowAudition = videoInfoRespVOS?.length;
    },
    // 查教师列表
    async getTeacher(teacherIds) {
      const { data } = await reqTeacherList(teacherIds, 1);
      this.teacherList = data;
    },
    // 查服务
    async getDictionary(serviceList) {
      const { data } = await reqTypeList('VIP_SERVICES');
      const learnServiceArr = data
        .filter((item) => serviceList.some((subItem) => Number(item.code) === Number(subItem)))
        .map((item) => {
          const { remark, value, code } = item;
          const { title, icon } = JSON.parse(remark);
          return {
            title,
            icon,
            content: value,
            code,
          };
        });
      console.log(learnServiceArr, 'learnServiceArr');
      this.learnServiceList = [...learnServiceArr];
    },
    teachMainModule(data) {
      return data.map((item) => item.discipline);
    },
    // 跳转 试听（原生交互）
    toAudition() {
      const { name, productId, productSkuRespVOList } = this.courseDetail;
      const { containCurriculumId } = productSkuRespVOList?.[0];
      if (this.$root.$data.isApp) {
        this.$sendToApp(
          'goTrialCoursePage',
          {
            courseId: productId,
            productCurriculumId: containCurriculumId,
            courseName: name,
          },
          false,
        );
      } else {
        this.$router.push({
          path: '/audition',
          query: {
            coursesId: productId,
            containCurriculumId: containCurriculumId,
          },
        });
      }
    },
    // 跳教师详情
    toTeacherDetail(data) {
      const url = `${window.location.origin}/ark/teacherDetail?teacherId=${data.id}`;
      if (this.miniprogram) {
        wx.miniProgram.navigateTo({
          url: `/subPackages/webView/webView?url=${encodeURIComponent(url)}`,
        });
        return;
      }
      if (this.isApp) {
        this.$sendToApp('openNewWebView', { url }, false);
        return;
      }
      this.$router.push({
        path: '/teacherDetail',
        query: {
          teacherId: data.id,
        },
      });
    },
    // asd
    toServer(i) {
      const { courseId } = this.classInfo;
      this.$router.push({
        path: '/vipExperience',
        query: {
          active: i,
          courseId,
          serviceList: this.serviceList.toString(),
        },
      });
    },
    toDetail() {
      const { courseId } = this.$route.query;
      // 判断是否App
      if (this.$root.$data.isApp) {
        this.$sendToApp('goCourseDetail', Number(courseId), false);
        return;
      }
      sessionStorage.setItem('back', true);
      this.$router.push({
        path: '/courseDetail',
        query: {
          courseId,
        },
      });
    },
    async toBuy() {
      const { productSkuRespVOList, isRepeatBuy } = this.courseDetail;
      const { courseId } = this.$route.query;
      if (!this.userInfo?.id) {
        this.toLogin();
        return;
      }
      if (!isRepeatBuy && this.buyInfo?.length) {
        this.$toast('产品不支持重复购买');
        return;
      }
      if (productSkuRespVOList.length > 1) {
        this.$refs.sku.show = true;
      } else {
        const skuid = productSkuRespVOList?.[0]?.productSkuId;
        this.buyCourse(courseId, skuid);
      }
    },
    async buyCourse(courseId, productSkuId) {
      const param = [{ productId: courseId, skuId: productSkuId }];
      this.$router.push({
        path: '/payOrder',
        query: { product: JSON.stringify(param) },
      });
    },
    // 查开课状态
    async checkCourse(id) {
      const { data } = await reqIsBuyProduct(id);
      this.buyInfo = data;
    },
    async sendSku(data) {
      this.$refs.sku.show = false;
      const { productId, productSkuId } = data;
      this.buyCourse(productId, productSkuId);
    },
    // 去登录
    toLogin() {
      if (this.isApp) {
        this.$sendToApp('login', {}, true);
      } else if (this.miniprogram) {
        let url = window.location.href;
        const [domain, searchParams] = url.split('?');
        if (searchParams) {
          const params = searchParams.split('&');
          const paramsMap = new Map();
          params.forEach((item) => {
            const [key, value] = item.split('=');
            //  console.log('key', key, value);
            if (key) {
              paramsMap.set(key, value);
            }
          });
          const entries = paramsMap.entries();
          let query = '';
          const ExcludequeryArr = ['THIRD_SESSION', 'env'];
          // eslint-disable-next-line no-restricted-syntax
          for (const [key, value] of entries) {
            if (!ExcludequeryArr.includes(key)) query += `${key}=${value}&`;
          }
          url = `${domain}?${query}`;
          const redirctUrl = encodeURIComponent(
            `/subPackages/detailWebView/index?url=${encodeURIComponent(url)}`,
          );
          const path = `/subPackages/loginPage/loginPage?isHandle=1&isWebview=1&isCancelgoBack=1&redirctUrl=${redirctUrl}`;
          wx.miniProgram.redirectTo({
            url: path,
          });
        }
      } else {
        const param = { redirect: '/studyBookExperience', ...this.$route.query };
        this.$router.push({
          path: '/registrationLogin',
          query: param,
        });
      }
    },
    async getLoginAfter() {
      await this.$root.getUserInfo();
    },
    // app 登录回掉
    getLogin(APPSESSION) {
      const ua = navigator.userAgent.toLowerCase();
      const cookieToken = /ohos/.test(ua) ? APPSESSION.token : APPSESSION;
      if ((window?.navigator?.userAgent || '').includes('iqihang')) {
        window.localStorage.setItem('accessToken', cookieToken || '');
        this.getLoginAfter();
      }
    },
  },
  created() {},
  mounted() {
    this.getCourseDetail();
    window['iqhApp2jsBridge.triggerSC'] = {};
    setTimeout(() => {
      // 获取登录状态
      window['iqhApp2jsBridge.triggerSC'].getLogin = this.getLogin;
    }, 100);
  },
};
</script>
<style lang="scss" scoped>
::-webkit-scrollbar {
  display: none;
}
.page.active {
  padding-top: 0;
}
.page {
  max-width: 750px;
  min-height: 100vh;
  margin: 0 auto;
  padding-top: 100px;
  padding-bottom: 180px;
  background: #f7f8fc;
  ::v-deep .commonTitle .titleName{
    padding-left: 200px;
  }
  .ad {
    img {
      width: 100%;
      max-height: 422px;
    }
  }
  .teacher {
    position: relative;
    top: -49px;
    z-index: 1;
    box-sizing: border-box;
    width: 678px;
    margin: 0 auto;
    padding: 29px 0 29px 29px;
    background: #fff;
    border-radius: 14px;
    .title {
      padding: 0;
    }
    .banner {
      display: flex;
      flex-shrink: 0;
      flex-wrap: nowrap;
      align-items: flex-start;
      overflow-x: scroll;
      .slide {
        position: relative;
        width: 620px;
        margin-right: 14px;
        padding-top: 43px;
        // height: 350px;
        border-radius: 14px 54px 14px 14px;
        .img {
          position: absolute;
          top: 0;
          right: 51px;
          z-index: 10;
          width: 159px;
          height: 175px;
          overflow: hidden;
          img {
            width: 100%;
          }
        }
        .head {
          position: relative;
          box-sizing: border-box;
          width: 620px;
          height: 132px;
          padding: 22px 0 0 54px;
          overflow: hidden;
          background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/studyBook/teacher-bg.png')
            no-repeat;
          background-size: 100%;
          border-radius: 14px 54px 0 0;

          .name {
            color: #fff;
            font-weight: 600;
            font-size: 33px;
          }
          .teacherMajors {
            display: flex;
            margin-top: 7px;
            span {
              display: inline-block;
              margin-right: 7px;
              padding: 0 11px;
              color: #ff7f41;
              font-weight: 400;
              font-size: 25px;
              line-height: 36px;
              background: linear-gradient(90deg, #fff 0%, #ffe3cc 100%);
              border: 1px solid #fff;
              border-radius: 14px 4px 14px 4px;
            }
          }
        }
        .desc {
          box-sizing: border-box;
          height: 217px;
          padding: 22px 29px;
          background: #fff7f0;
          border-radius: 0  0 14px  14px;
          div {
            display: -webkit-box;
            overflow: hidden;
            color: #333;
            font-weight: 400;
            font-size: 25px;
            line-height: 43px;
            text-overflow: ellipsis;
            word-break: break-all;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 4;
          }
        }
      }
    }
  }
  .title {
    padding-bottom: 22px;
    color: #333;
    font-weight: 500;
    font-size: 29px;
    line-height: 40px;
  }
  .main {
    position: relative;
     top: -27px;
    width: 678px;
    margin: 0 auto 22px;
    padding: 29px;
    background: #fff;
    border-radius: 14px;

    .cover {
      position: relative;
      .img {
        width: 620px;
        height: 447px;
        border-radius: 14px;
      }
      .audition {
        position: absolute;
        right: 29px;
        bottom: 29px;
        width: 210px;
        height: 65px;
      }
    }
  }
  .server {
    position: relative;
    top: -27px;
    width: 678px;
    margin: 0 auto;
    padding: 29px 29px 0 29px;
    background: #fff;
    border-radius: 14px;
    .box {
      display: flex;
      flex-wrap: wrap;
      .item:nth-child(5n) {
        margin-right: 0;
      }
      .item {
        width: 120px;
        margin: 0 5px 22px 0;
        img {
          display: block;
          width: 72px;
          height: 72px;
          margin: 0 auto;
        }
        p {
          padding-top: 11px;
          color: #333;
          font-weight: 400;
          font-size: 22px;
          text-align: center;
        }
      }
    }
  }
  .foot {
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    width: 750px;
    height: 167px;
    margin: 0 auto;
    padding: 22px 36px;
    background: #fff;
    border-radius: 22px 22px 2px 2px;
    box-shadow: 0 -4 14px 0 rgba(0, 0, 0, 0.05);
    div {
      width: 330px;
      height: 80px;
      font-weight: 500;
      font-size: 29px;
      line-height: 80px;
      text-align: center;
      border: 2px solid #ff7f41;
      border-radius: 49px;
    }
    .look {
      color: #ff7f41;
    }
    .buy {
      color: #fff;
      background: #ff7f41;
    }
  }
}
</style>
